import classes from "./SignUp.module.css";
import { Fragment, useState, useContext } from "react";
import AuthContext from "../../store/auth-context";
import useInput from "../Hooks/use-input";
import { getAuthToken } from "../../util/auth";
import { Link, useNavigate } from "react-router-dom";
import { getApiChara } from "../../util/getApi";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { FaUserPlus, FaIdCard, FaUserShield, FaEnvelope, FaPhoneAlt, FaGraduationCap, FaLock, FaTimes, FaSave } from 'react-icons/fa';
import { Spinner } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import ConfirmModal from "../UI/ConfirmModal";

const SignUp = (props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const authCtx = useContext(AuthContext);

  const [role, setRole] = useState("");
  const [roleError, setRoleError] = useState(false);
  const [enteredconPassword, setEnteredconPassword] = useState('');
  const [conPasswordTouched, setConPasswordTouched] = useState(false);



  const {
    value: enteredName,
    isValid: enterednameIsValid,
    hasError,
    inputValueHandler: nameInputChangeHandler,
    inputBlurHandler: nameInputBlurHandler,
  } = useInput("blankval");

  const {
    value: enteredUName,
    isValid: enteredUNameIsValid,
    hasError: userUNameHasError,
    inputValueHandler: uNameInputChangeHandler,
    inputBlurHandler: uNameInputBlurHandler,
  } = useInput("blankval");

  const {
    value: enteredMName,
    isValid: enteredMNameIsValid,
    hasError: middleNameHasError,
    inputValueHandler: mNameInputChangeHandler,
    inputBlurHandler: mNameInputBlurHandler,
  } = useInput("blankval");

  const {
    value: enteredMobile,
    isValid: enteredMobileIsValid,
    hasError: MobileInputHaError,
    inputValueHandler: mobileInputChangeHandler,
    inputBlurHandler: mobileInputBlurHandler,
  } = useInput("numcheck");

  const {
    value: enteredEmail,
    isValid: enteredEmailIsValid,
    hasError: EmailInputHaError,
    inputValueHandler: emailInputChangeHandler,
    inputBlurHandler: emailInputBlurHandler,
  } = useInput("emailcheck");

  const {
    value: enteredPassword,
    isValid: enteredPasswordIsValid,
    hasError: PasswordInputHaError,
    inputValueHandler: passwordInputChangeHandler,
    inputBlurHandler: passwordInputBlurHandler,
  } = useInput("blankval");

  const {
    value: enteredLName,
    isValid: enteredLNameIsValid,
    hasError: lastNameError,
    inputValueHandler: lastNameInputChangeHandler,
    inputBlurHandler: lastNameInputBlurHandler,
  } = useInput("blankval");

  const {
    value: enteredDegName,
    isValid: enteredDegNameIsValid,
    hasError: degreeNameHasError,
    inputValueHandler: degNameInputChangeHandler,
    inputBlurHandler: degNameInputBlurHandler,
  } = useInput("blankval");

  const conPasswordHasError = conPasswordTouched && enteredPassword !== enteredconPassword;

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showConfirmModal, setShowConfirmModal] = useState(false);

  const roleChangeHandler = (e) => {
    setRole(e.target.value);
    if (e.target.value.trim() === "") {
      setRoleError(true);
    } else {
      setRoleError(false);
    }
  };

  const onFormSubmitHandler = (event) => {
    event.preventDefault();

    if (role.trim() === "") {
      setRoleError(true);
      return;
    }

    if (enteredPassword !== enteredconPassword || conPasswordHasError) {
      toast.error(t("Passwords do not match"));
      return;
    }

    setShowConfirmModal(true);
  };

  const fetchData = async () => {
    setShowConfirmModal(false);
    setIsSubmitting(true);
    const apiChar = getApiChara();
    const token = getAuthToken();
    const fetchApi = `${apiChar}/users/signup`;

    const userData = {
      firstName: enteredName,
      middleName: enteredMName,
      lastName: enteredLName,
      userName: enteredUName,
      mobile: enteredMobile,
      email: enteredEmail,
      degree: enteredDegName,
      password: enteredPassword,
      role: role,
      tenantOrClientId: authCtx.tenantOrClientId
    };

    try {
      const response = await fetch(fetchApi, {
        method: "post",
        body: JSON.stringify(userData),
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      if (response.status === 409) {
        const errorText = await response.text();
        toast.error(errorText);
        setIsSubmitting(false);
        return;
      }

      if (response.status >= 500 && response.status < 600) {
        navigate("/access-denied?errorCode=500&errorMessage=Server%20is%20offline&errorDescription=check%20your%20internet%20connection%20or");
        setIsSubmitting(false);
        return;
      }

      if (!response.ok) {
        toast.error(t("Could not save User"));
        setIsSubmitting(false);
        return;
      }

      await response.json();
      toast.success(t("User added successfully!"));
      navigate("..");
    } catch (error) {
      toast.error(t("Please check your network connection"));
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className={classes.cardview}>
      <h3 className='textHead' style={{ color: 'var(--primary-color)', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '1px', padding: '1.5rem 2rem 0 2rem', margin: 0 }}>
        <FaUserPlus className="me-2" /> {t("Register User")}
      </h3>
      <form onSubmit={onFormSubmitHandler} className={classes.form}>

        <div className={classes.sectionHeader}>
          <FaIdCard /> {t("Personal Information")}
        </div>

        <div className="row">
          <div className="col-md-4 col-6">
            <label className={classes.label} htmlFor="name">{t("First Name")} <span className={classes.reqSign}>*</span></label>
            <input
              type="text"
              className="form-control"
              value={enteredName}
              required
              onChange={nameInputChangeHandler}
              onBlur={nameInputBlurHandler}
              id="name"
            />
            {hasError && <p className={classes.errorText}>{t("Name is Invalid")}</p>}
          </div>

          <div className="col-md-4 col-6">
            <label className={classes.label} htmlFor="mname">{t("Middle Name")} <span className={classes.reqSign}>*</span></label>
            <input
              type="text"
              className="form-control"
              value={enteredMName}
              onChange={mNameInputChangeHandler}
              onBlur={mNameInputBlurHandler}
              id="mname"
              required
            />
            {middleNameHasError && <p className={classes.errorText}>{t("Name is Invalid")}</p>}
          </div>

          <div className="col-md-4 col-6">
            <label className={classes.label} htmlFor="lname"> {t("Last Name")} <span className={classes.reqSign}>*</span></label>
            <input
              type="text"
              required
              className="form-control"
              value={enteredLName}
              onChange={lastNameInputChangeHandler}
              onBlur={lastNameInputBlurHandler}
              id="lname"
            />
            {lastNameError && <p className={classes.errorText}>{t("Last Name is Invalid")}</p>}
          </div>

          <div className="col-md-6 col-12">
            <label className={classes.label} htmlFor="degname"> {t("Degree")} <span className={classes.reqSign}>*</span></label>
            <input
              type="text"
              className="form-control"
              value={enteredDegName}
              onChange={degNameInputChangeHandler}
              onBlur={degNameInputBlurHandler}
              id="degname"
              required
            />
            {degreeNameHasError && <p className={classes.errorText}>{t("Degree is Invalid")}</p>}
          </div>

          <div className="col-md-6 col-12">
            <label className={classes.label} htmlFor="role"> {t("Role")} <span className={classes.reqSign}>*</span></label>
            <select
              className="form-select"
              id="role"
              required
              onChange={roleChangeHandler}
              value={role}
            >
              <option value="">{t("Select Role")}</option>
              <option value="ROLE_ACCOUNTANT">{t("ROLE_ACCOUNTANT")}</option>
              <option value="ROLE_ADMIN">{t("ROLE_ADMIN")}</option>
              <option value="ROLE_DOCTOR">{t("ROLE_DOCTOR")}</option>
              <option value="ROLE_GUESTDOCTOR">{t("ROLE_GUESTDOCTOR")}</option>
              <option value="ROLE_MANAGER">{t("ROLE_MANAGER")}</option>
              <option value="ROLE_NURSE">{t("ROLE_NURSE")}</option>
              <option value="ROLE_PHARMACIST">{t("ROLE_PHARMACIST")}</option>
              <option value="ROLE_RECEPTIONIST">{t("ROLE_RECEPTIONIST")}</option>
            </select>
            {roleError && <p className={classes.errorText}>{t("Select Role")}</p>}
          </div>
        </div>

        <div className={classes.sectionHeader}>
          <FaUserShield /> {t("Account Credentials")}
        </div>

        <div className="row">
          <div className="col-md-4 col-12">
            <label className={classes.label} htmlFor="uname"> {t("User Name")} <span className={classes.reqSign}>*</span></label>
            <input
              type="text"
              className="form-control"
              value={enteredUName}
              required
              onChange={uNameInputChangeHandler}
              onBlur={uNameInputBlurHandler}
              id="uname"
            />
            {userUNameHasError && <p className={classes.errorText}>{t("User Name is Invalid")}</p>}
          </div>

          <div className="col-md-4 col-6">
            <label className={classes.label} htmlFor="pwd"> {t("Password")} <span className={classes.reqSign}>*</span></label>
            <input
              required
              type="password"
              value={enteredPassword}
              className="form-control"
              id="pwd"
              onChange={passwordInputChangeHandler}
              onBlur={passwordInputBlurHandler}
            />
            {PasswordInputHaError && <p className={classes.errorText}>{t("Password is Invalid")}</p>}
          </div>

          <div className="col-md-4 col-6">
            <label className={classes.label} htmlFor="conpwd">{t("Confirm Password *")}</label>
            <input
              required
              type="password"
              value={enteredconPassword}
              className="form-control"
              id="conpwd"
              onChange={(e) => setEnteredconPassword(e.target.value)}
              onBlur={() => setConPasswordTouched(true)}
            />
            {conPasswordHasError && <p className={classes.errorText} style={{ color: 'red', fontSize: '12px', marginTop: '4px' }}>{t("Passwords do not match")}</p>}
          </div>
        </div>

        <div className={classes.sectionHeader}>
          <FaPhoneAlt /> {t("Contact Information")}
        </div>

        <div className="row">
          <div className="col-md-6 col-12">
            <label className={classes.label} htmlFor="mobile"> {t("Mobile No")} <span className={classes.reqSign}>*</span></label>
            <input
              type="text"
              className="form-control"
              value={enteredMobile}
              id="mobile"
              required
              onChange={mobileInputChangeHandler}
              onBlur={mobileInputBlurHandler}
            />
            {MobileInputHaError && <p className={classes.errorText}>{t("Mobile is Invalid")}</p>}
          </div>

          <div className="col-md-6 col-12">
            <label className={classes.label} htmlFor="email"> {t("Email")} <span className={classes.reqSign}>*</span></label>
            <input
              type="email"
              className="form-control"
              value={enteredEmail}
              id="email"
              required
              onChange={emailInputChangeHandler}
              onBlur={emailInputBlurHandler}
            />
            {EmailInputHaError && <p className={classes.errorText}>{t("Email is Invalid")}</p>}
          </div>
        </div>

        <div className={classes.actions}>
          <button type="submit" disabled={isSubmitting} className="d-flex align-items-center">
            {isSubmitting ? <Spinner animation="border" size="sm" className="me-2" /> : <FaSave className="me-2" />}
            {isSubmitting ? t("Submitting...") : t('Submit')}
          </button>
          <Link to='..' className={classes.cancelBtn}>
            <FaTimes className="me-2" /> {t("Cancel")}
          </Link>
        </div>
      </form>
      <ConfirmModal
        show={showConfirmModal}
        onHide={() => setShowConfirmModal(false)}
        onConfirm={fetchData}
        title={t("Register User")}
        message={t("Are you sure you want to register this user?")}
        variant="primary"
        confirmText={t("Confirm Registration")}
      />
    </div>
  );
};

export default SignUp;
